import { Typography } from '@mui/material';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { useDashboardCapabilities } from './dashboardCapabilities';

/** Tab intro copy; in historic mode or during a program run shows the drag-disabled message instead. */
const DashboardDrawerTabDescription = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation();
  const { isHistoric, isLayoutLocked } = useDashboardCapabilities();

  let description = children;
  if (isHistoric) {
    description = t(
      'dashboard.drawer.historicDragDisabled',
      'Widgets cannot be added in Historic mode. Switch to Live to drag widgets onto the dashboard.'
    );
  } else if (isLayoutLocked) {
    description = t(
      'dashboard.drawer.programRunningDragDisabled',
      'Widgets cannot be added while a program is running. Stop the program to add widgets.'
    );
  }

  return (
    <Typography variant="body2" sx={{ width: '100%', mb: 2 }}>
      {description}
    </Typography>
  );
};

export default DashboardDrawerTabDescription;
